import { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  BsFillTelephoneFill,
  BsFillEnvelopeFill,
  BsFillGeoAltFill,
} from "react-icons/bs";
import Button from "react-bootstrap/Button";
import ShowAlert from "./Alert";
import Loader from "./Loader";
import emailjs from "@emailjs/browser";
import TurnstileWidget from "./TurnstileWidget";
import { useTranslation } from "react-i18next";

export const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [user_name, setName] = useState("");
  const [user_email, setEmail] = useState("");
  const [user_subject, setSubject] = useState("");
  const [user_message, setMessage] = useState("");
  const [verificationResult, setVerificationResult] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Lander De Kesel - Contact";
    window.scrollTo(0, 0);
    AOS.init();
  }, []);

  const handleVerification = (result) => {
    setVerificationResult(result);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const data = { user_name, user_email, user_subject, user_message };
    setLoading(true);
    setAlert(null);
    emailjs
      .send("service_mpyl5he", "template_zljbpnq", data, "oLFY5bLKiHMMjaxsg")
      .then(
        (result) => {
          console.log(result.text);
          setAlert({
            variant: "success",
            message: t("shared.email_sent"),
          });
          setTimeout(() => {
            setAlert(null);
          }, 10000);
          setLoading(false);
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          setAlert({
            variant: "danger",
            message: error.text,
          });
          setTimeout(() => {
            setAlert(null);
          }, 10000);
          setLoading(false);
          e.target.reset();
        }
      );
  };

  return (
    <>
      {alert !== null ? (
        <ShowAlert variant={alert.variant} message={alert.message} />
      ) : (
        ""
      )}
      <section className="contactContainer">
        <div className="contactContainerLeft">
          <h1>
            {t("contact.contact")}{" "}
            <span style={{ color: "#0077ff" }}>{t("contact.me")}</span>.
          </h1>
          <div
            data-aos-duration="2000"
            data-aos="fade-up"
            className="contactDetailsContainer"
          >
            <div className="contactDetailsNaastElkaar">
              <BsFillTelephoneFill
                style={{ paddingTop: "20px", color: "#0077ff" }}
                size={20}
              />
              <h4>+32479583092</h4>
            </div>
            <div className="contactDetailsNaastElkaar">
              <BsFillEnvelopeFill
                style={{ paddingTop: "20px", color: "#0077ff" }}
                size={20}
              />
              <h4>contact@landerdekesel.com</h4>
            </div>
            <div className="contactDetailsNaastElkaar">
              <BsFillGeoAltFill
                style={{ paddingTop: "20px", color: "#0077ff" }}
                size={20}
              />
              <h4>{t("contact.address")}</h4>
            </div>
          </div>
        </div>
        <div className="contactContainerRight">
          <h3>{t("contact.title")}</h3>
          <form
            ref={form}
            onSubmit={sendEmail}
            className="contactFormContainer"
            data-aos-delay="500"
            data-aos-duration="1500"
            data-aos="fade-left"
          >
            <div className="contactNameContainer">
              <div>
                <label htmlFor="user_name">
                  {t("shared.form.name")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  id="user_name"
                  name="user_name"
                  type="text"
                  className="dropdownInput"
                  required="required"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="user_email">
                  {t("shared.form.email")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  id="user_email"
                  name="user_email"
                  type="email"
                  className="dropdownInput"
                  required="required"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="user_subject">
                  {t("shared.form.subject")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  id="user_subject"
                  name="user_subject"
                  type="text"
                  className="dropdownInput"
                  required="required"
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="user_message">
                  {t("shared.form.message")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <textarea
                  className="dropdownInput"
                  id="user_message"
                  name="user_message"
                  style={{ maxWidth: "100vh", height: "100px" }}
                  required="required"
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>
            </div>
            <TurnstileWidget onVerification={handleVerification} />
            <div>
              {loading ? (
                <Loader loading={loading} />
              ) : (
                <Button
                  type="submit"
                  className="authButtons"
                  disabled={!verificationResult}
                >
                  {t("shared.submit")}
                </Button>
              )}
            </div>
          </form>
        </div>
      </section>
    </>
  );
};
